<script lang="ts">
	import {
		AddToCart,
		type AddToCartProps,
	} from '#lib/features/checkout/components/AddToCart/index.js';

	import { DropType } from '#lib/features/checkout/constants/drop-types.js';
	import { getCartIconContext } from '#lib/features/checkout/utils/getCartIconContext/index.js';
	import type { ButtonSize } from '$global/components/Button';

	interface Props {
		dataCy: string;
		size?: ButtonSize;
		label?: string | null | undefined;
		icon?: AddToCartProps['icon'] | undefined;
		productId: AddToCartProps['productId'];
		cartItem: AddToCartProps['cartItem'];
		class?: string;
		disabled?: boolean;
	}

	let {
		dataCy,
		size = 'md',
		icon = 'leading',
		productId,
		disabled,
		cartItem,
		label,
		...rest
	}: Props = $props();

	const { dropTypes } = getCartIconContext();
</script>

<AddToCart {disabled} {size} {icon} {dataCy} {productId} {cartItem} {...rest}>
	{#if productId}
		{label ||
			`Add to ${
				$dropTypes?.[productId]?.type === DropType.Application
					? 'application'
					: 'cart'
			}`}
	{/if}
</AddToCart>
